import { VALUE_SCORE_ANALYSIS } from '../../../../../../../../../tool/dynamicReport/constant'

export const TYPE_CHART_RISK = [
  {
    name: 'company',
    id: 1,
    color: '#006AA6',
    dataKey: 'data1',
    dataFloatBar: 'dataFloatBar1',
  },
  {
    name: 'industry',
    id: 2,
    color: '#F49966',
    dataKey: 'data2',
    dataFloatBar: 'dataFloatBar2',
  },
  {
    name: 'region',
    id: 3,
    color: '#00A8B5',
    dataKey: 'data3',
    dataFloatBar: 'dataFloatBar3',
  },
  {
    name: 'year',
    id: 4,
    color: '#C06C84',
    dataKey: 'data4',
    dataFloatBar: 'dataFloatBar4',
  },
]

export const TYPE_CHECK_CHART_DYNAMIC = {
  [VALUE_SCORE_ANALYSIS.COMPANY]: 'data1',
  [VALUE_SCORE_ANALYSIS.INDUSTRY]: 'data2',
  [VALUE_SCORE_ANALYSIS.REGION]: 'data3',
  [VALUE_SCORE_ANALYSIS.YEAR]: 'data4',
}

export const TYPE_ID_OPTION_CORPORATE = {
  COMPANY: 1,
  INDUSTRY: 2,
  REGION: 3,
  YEAR: 4,
}

export const COLOR_CHART_DISTRIBUTION = {
  ACTIVE: '#FFCD60',
  NOT_ACTIVE: '#006AA6',
}

export const TYPE_RADIO_DISTRIBUTION = {
  industry: {
    name: 'industry',
    value: 1,
  },
  region: {
    name: 'region',
    value: 2,
  },
  year: {
    name: 'year',
    value: 3,
  },
}
